export default {
  getIconByDocument(document) {
    switch (document.type) {
      case "Email":
        return "mdi mdi-at";

      case "Document":
        return "mdi mdi-file";

      case "Letter":
        return "mdi mdi-email";

      case "Note":
        return "mdi mdi-message-bulleted";

      default:
        return "mdi mdi-paperclip";
    }
  },
};
